import { render, staticRenderFns } from "./AnexoEdicaoDlg.vue?vue&type=template&id=28a13036"
import script from "./AnexoEdicaoDlg.vue?vue&type=script&lang=js"
export * from "./AnexoEdicaoDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports